Number.prototype.between = function (a, b, inclusive) {
   var min = Math.min.apply(Math, [a, b]),
      max = Math.max.apply(Math, [a, b]);
   return inclusive ? this >= min && this <= max : this > min && this < max;
};


$(document).ready(function () {
   showDefaultPayment();
   showDefalultFieldVal();
});

function showDefalultFieldVal() {
   /*var below_1000 = 0.02475; 
   var bet_1k_5k = 0.02153; 
   var bet_5k_12k =0.02082; 
   var bet_12k_25k =0.02059;
   var bet_25k_50k =0.01967;
   var greater_50k =0.01944;

   $('#FinanceCalculatorForm_below_1000').val(below_1000);
   $('#FinanceCalculatorForm_bet_1k_5k').val(bet_1k_5k);
   $('#FinanceCalculatorForm_bet_5k_12k').val(bet_5k_12k);
   $('#FinanceCalculatorForm_bet_12k_25k').val(bet_12k_25k);
   $('#FinanceCalculatorForm_bet_25k_50k').val(bet_25k_50k);
   $('#FinanceCalculatorForm_greater_50k').val(greater_50k);*/


   var selmonth = $('#FinanceCalculatorForm_selmonth').val();
   var below_1000 = 0;
   var bet_1k_5k = 0;
   var bet_5k_12k = 0;
   var bet_12k_25k = 0;
   var bet_25k_50k = 0;
   var greater_50k = 0;

   if (selmonth == 'months_24') {
      below_1000 = 0.5116;
      bet_1k_5k = 0.04810;
      bet_5k_12k = 0.04648;
      bet_12k_25k = 0.04555;
      bet_25k_50k = 0.04513;
      greater_50k = 0.04513;

   } else if (selmonth == 'months_36') {
      below_1000 = 0.03538;
      bet_1k_5k = 0.03243;
      bet_5k_12k = 0.03177;
      bet_12k_25k = 0.03155;
      bet_25k_50k = 0.03068;
      greater_50k = 0.03047;
   } else if (selmonth == 'months_48') {
      below_1000 = 0.02357;
      bet_1k_5k = 0.02379;
      bet_5k_12k = 0.02469;
      bet_12k_25k = 0.02491;
      bet_25k_50k = 0.02560;
      greater_50k = 0.02868;
   } else if (selmonth == 'months_60') {
      below_1000 = 0.02475;
      bet_1k_5k = 0.02153;
      bet_5k_12k = 0.02082;
      bet_12k_25k = 0.02059;
      bet_25k_50k = 0.01967;
      greater_50k = 0.01944;
   }
   $('#FinanceCalculatorForm_below_1000').val(below_1000);
   $('#FinanceCalculatorForm_bet_1k_5k').val(bet_1k_5k);
   $('#FinanceCalculatorForm_bet_5k_12k').val(bet_5k_12k);
   $('#FinanceCalculatorForm_bet_12k_25k').val(bet_12k_25k);
   $('#FinanceCalculatorForm_bet_25k_50k').val(bet_25k_50k);
   $('#FinanceCalculatorForm_greater_50k').val(greater_50k);

}

function hideBtn() {
   //$("#ContactFormApplyNowBtn").attr("disabled", true);
}

function showBtn() {
   //$("#ContactFormApplyNowBtn").attr("disabled", false);
}

function round(value, precision) {
   var multiplier = Math.pow(10, precision || 0);
   return (Math.round(value * multiplier) / multiplier).toFixed(2);
}
var max_val = 9999999999999999;

function calculatePayment() {
   var cost_val = parseFloat($('#FinanceCalculatorForm_cost').val());
   if (isAllOk()) {

      var months_24_fact = 0;
      var months_36_fact = 0;
      var months_48_fact = 0;
      var months_60_fact = 0;
      var temp_tot = 0;
      var temp_factor = 0;
      //if($('#ContactFormLessTwoYears').prop("checked") == false){

      if (cost_val.between(0, 1000, true)) {
         //(4500 + (4500 x 0.02153)) / 24
         temp_factor = parseFloat($('#FinanceCalculatorForm_below_1000').val());

      } else if (cost_val.between(1001, 5000, true)) {
         temp_factor = parseFloat($('#FinanceCalculatorForm_bet_1k_5k').val());
      } else if (cost_val.between(5000, 12000, true)) {
         temp_factor = parseFloat($('#FinanceCalculatorForm_bet_5k_12k').val());
      } else if (cost_val.between(12001, 25000, true)) {
         temp_factor = parseFloat($('#FinanceCalculatorForm_bet_12k_25k').val());
      } else if (cost_val.between(250001, 50000, true)) {
         temp_factor = parseFloat($('#FinanceCalculatorForm_bet_25k_50k').val());
      } else if (cost_val.between(50000, max_val, true)) {
         temp_factor = parseFloat($('#FinanceCalculatorForm_greater_50k').val());
      }
      temp_tot = cost_val + (cost_val * temp_factor);
      months_24_fact = temp_tot / 24;
      months_36_fact = temp_tot / 36;
      months_48_fact = temp_tot / 48;
      months_60_fact = temp_tot / 60;
      /*}
      else{
      	months_24_fact =   0.06159;
      	months_36_fact =   0.04784;
      	months_48_fact =   0.04139;
      	months_60_fact =   0.03783;
      }*/

      months_24_fact_final = round(months_24_fact * 1, 2);
      months_36_fact_final = round(months_36_fact * 1, 2);
      months_48_fact_final = round(months_48_fact * 1, 2);
      months_60_fact_final = round(months_60_fact * 1, 2);
      $('#months_24_fact_html').html('<p>' + months_24_fact_final + '</p>');
      $('#months_36_fact_html').html('<p>' + months_36_fact_final + '</p>');
      $('#months_48_fact_html').html('<p>' + months_48_fact_final + '</p>');
      $('#months_60_fact_html').html('<p>' + months_60_fact_final + '</p>');

   } else {
      // reset to defalut
      $('#months_24_fact_html').html('<p>N/A</p>');
      $('#months_36_fact_html').html('<p>N/A</p>');
      $('#months_48_fact_html').html('<p>N/A</p>');
      $('#months_60_fact_html').html('<p>N/A</p>');
   }
}

function showDefaultPayment() {
   $('#months_24_fact_html').html('<p>N/A</p>');
   $('#months_36_fact_html').html('<p>N/A</p>');
   $('#months_48_fact_html').html('<p>N/A</p>');
   $('#months_60_fact_html').html('<p>N/A</p>');
}

function isAllOk() {
   var cost_val = parseFloat($('#FinanceCalculatorForm_cost').val());
   //var errors;
   max_val = 9999999999999999;
   if (cost_val) {

      /*if($('#ContactFormLessTwoYears').prop("checked") == true){
      	if(cost_val>35000){
      		max_val = 35000;
      		$('#FinanceCalculatorForm_cost').val(35000);
      	}
      }*/
      cost_val = parseFloat($('#FinanceCalculatorForm_cost').val());
      //return true;
      if (!cost_val.between(0, max_val, true)) {
         return false;
      } else {
         return true;
      }
   } else {
      return false;
   }
}

function isFloatKey(evt, obj) {

   var charCode = (evt.which) ? evt.which : event.keyCode
   var value = obj.value;
   var dotcontains = value.indexOf(".") != -1;
   if (dotcontains)
      if (charCode == 46) return false;
   if (charCode == 46) return true;
   if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
   return true;
}

$('#FinanceCalculatorForm_cost').on('blur', function () {

   if (!isAllOk()) {
      $(this).addClass('error');
      //hideBtn();
      showDefaultPayment();
   } else {
      if ($(this).hasClass('error')) {
         $(this).removeClass('error');
      }
      //showBtn();
      calculatePayment();
   }
   // $('#FinanceCalculatorForm_cost').rules('add', {  required: true,  messages: { ContactForm_cost: 'Cost must be in between $5000 and $35000' } });
   // $('#ContactForm').valid();
}).on('focus', function () {
   if ($(this).hasClass('error')) {
      $(this).removeClass('error');
   }
   //showBtn();
   showDefaultPayment();
});

$('#FinanceCalculatorForm_selmonth').change(function () {
   //v.element('#FinanceCalculatorForm_name'); 
   if ($.trim($(this).val()).length == 0) {
      $(this).addClass('error');
      //hideBtn();
   } else {
      if ($(this).hasClass('error')) {
         $(this).removeClass('error');
      }
   }

   showDefalultFieldVal();


});

/*$('#FinanceCalculatorForm_below_1000,#FinanceCalculatorForm_bet_1k_5k,#FinanceCalculatorForm_bet_5k_12k,#FinanceCalculatorForm_bet_12k_25k,#FinanceCalculatorForm_bet_25k_50k,#FinanceCalculatorForm_greater_50k').on('blur', function () {
	$('.custom_mandatory').each(function(){
		 //alert("checking");
		  if ($.trim($(this).val()).length == 0){
			$(this).addClass('error');
			ind = false;
		  }else{
			if($(this).hasClass('error')){
			 $(this).removeClass('error');
			} 
		  }
	 });
});	*/

$('#ContactFormApplyNowBtn').on('click', function (e) {

   window.location.href = 'https://sls.secure2050.com/App/VCXVPublicApp.vcxv?SubscriberID=1016&CompanyNum=1&UserNum=7&ApplicationFormat=G';

   e.preventDefault();

   var ind = true;
   $('.custom_mandatory').each(function () {
      //alert("checking");
      if ($.trim($(this).val()).length == 0) {
         $(this).addClass('error');
         ind = false;
      } else {
         if ($(this).hasClass('error')) {
            $(this).removeClass('error');
         }
      }
   });


   //
   if (!isAllOk()) {
      $('#FinanceCalculatorForm_cost').addClass('error');
      //ind = false;
   }


   if (ind) {

      $('#FinanceCalculatorForm').submit();
   } else {

      return true;
   }

});

$('#FinanceCalculatorForm_calculate_btn').on('click', function () {
   // alert("calling");
   //Mandatory fields check
   var ind = true;
   $('.custom_mandatory').each(function () {
      //alert("checking");
      if ($.trim($(this).val()).length == 0) {
         $(this).addClass('error');
         ind = false;
      } else {
         if ($(this).hasClass('error')) {
            $(this).removeClass('error');
         }
      }
   });

   //
   if (!isAllOk()) {
      $('#FinanceCalculatorForm_cost').addClass('error');
      ind = false;
   }


   if (ind) {
      //showBtn();
      calculatePayment();
   } else {
      //hideBtn();	
      showDefaultPayment();
   }


});